export default __webpack_public_path__ + "static/media/Home-Value-Marketplace.2640a91b.jpg";